import { SupplierAdsCampaignScreen } from 'src/screens/Supplier/SupplierAdsCampaignScreen';
import { SupplierListScreen } from '../screens/Supplier/SupplierListScreen';
import { AddSupplierFeeScreen } from 'src/screens/Supplier/AddSupplierFeeScreen';

export const SupplierRoutes = [
  { path: '/supplier/list', exact: true, component: SupplierListScreen },
  { path: '/supplier/ads', exact: true, component: SupplierAdsCampaignScreen },
  { path: '/supplier/add_fee/:id', exact: true, component: AddSupplierFeeScreen },
];
